<script setup lang="ts">
import { CustomMarker } from 'vue3-google-map';
import Typography from '@components/Typography.vue';
import type { GoogleMapLatLngLiteral } from '@global-types/googleMap.ts';

interface MarkerProps {
  position: GoogleMapLatLngLiteral,
  isHighlighted?: boolean,
  zIndex?: number,
}

withDefaults(defineProps<MarkerProps>(), {
  isHighlighted: false,
  zIndex: 0,
});
</script>

<template>
  <CustomMarker
    :options="{
      position,
      anchorPoint: 'BOTTOM_CENTER',
      zIndex: isHighlighted ? 200 : zIndex,
    }"
  >
    <Typography
      variant="body-small-bold"
      class="marker"
      :class="{ 'marker--highlighted': isHighlighted }"
    >
      <slot />
    </Typography>
  </CustomMarker>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

@mixin marker-highlighted {
  background-color: $colorGrayDarker;
  border-color: $colorGrayDarker;
  color: $colorWhite;
}

.marker {
  border: 1px solid $colorGray;
  border-radius: rem(8);
  background-color: $colorWhite;
  box-shadow: 0 rem(4) rem(8) 0 #00000059;
  padding: rem(4) rem(8);
  overflow: hidden;
  cursor: pointer;

  &--highlighted {
    @include marker-highlighted;
  }

  @media (hover: hover) {
    &:hover {
      @include marker-highlighted;
    }
  }
}
</style>
